import React from 'react';
import styles from './innerButton.module.scss';
import Text from '../text/Text';

import Loader from '../loader/Loader';

const InnerButton = ({
  fontSize,
  title,
  style,
  onClick,
  reverse,
  svg,
  toUppercase,
  type,
  className,
  buttonClassName,
  disabled,
  isLoading,
}) => {
  return (
    <button
      onClick={onClick}
      className={`${styles.button} ${reverse ? styles.reverse : ''} ${
        buttonClassName ?? ''
      } ${disabled ? styles.disabled : ''}`}
      style={style}
      type={type}
      disabled={disabled}
    >
      <Text
        title={title}
        fontSize={fontSize}
        variant={reverse ? 'text-regular-16' : 'text-bold-italic-16-black'}
        style={{
          textTransform: toUppercase ? 'uppercase' : '',
          cursor: 'pointer',
        }}
        className={className}
        svg={reverse ? svg : ''}
        textContainerStyle={{ textAlign: 'center' }}
      />
      {isLoading && (
        <div className={styles.buttonLoader}>
          <Loader style={{ width: '20px', height: '20px' }} />
        </div>
      )}
    </button>
  );
};

export default InnerButton;
